/**
 * Function for creating a delay
 * @param waitTime
 */
const wait = async (waitTime: number) => {
  return new Promise<void>(resolve => {
    setTimeout(async () => {
      resolve();
    }, waitTime);
  });
};

export default wait;
